import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import StepActive from 'loyal-design-system/assets/images/step-active.png'
import StepPending from 'loyal-design-system/assets/images/step-pending.png'
import { Icon } from 'loyal-react'

const setClassName = (completed) => {
  return completed ? 'color-brand-2-like' : 'color-ui-3'
}

function RequestCardStage ({ icon, text, completed }) {
  return (
    <div className='d-flex flex-column justify-content-center align-items-center'>
      <MediaQuery minDeviceWidth={768}>
        <Icon iconName={icon} className={setClassName(completed) + ' mb-1'} />
      </MediaQuery>
      <MediaQuery maxDeviceWidth={767}>
        <img className='mb-2' src={completed ? StepActive : StepPending} />
      </MediaQuery>
      <p>
        <small className={setClassName(completed)}>
          <strong>{text}</strong>
        </small>
      </p>
    </div>
  )
}

RequestCardStage.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  completed: PropTypes.bool
}

export default RequestCardStage



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/RequestCardStage.js